module.exports = __webpack_public_path__ + "img/744.7e071680.jpg";